import $ from 'jquery';
import * as React from 'react';
import ReactDOM from 'react-dom';
import App from '../components/react/App';

$(document).ready((e) => {
    ReactDOM.render(<App/>, document.querySelector('#museums-app'));
});
